module.exports = __webpack_public_path__ + "img/homepro4.2d8c0054.jpeg";